import type { RootState } from 'state/reducers';
import type { Errors } from 'state/shared/types';

export const selectPending = (state: RootState): boolean =>
  state.signIn.pending;

export const selectErrors = (state: RootState): Errors => state.signIn.errors;
